import React, { FC } from 'react';
import styled from 'styled-components';
import { Price as PriceType } from 'shared-types/Common';
import { Price as PriceUnstyled } from '../../../../../Price';
import { PricingType, PricingTypeEnum } from '../PricingType';
import { PriceWrapper } from './Price.styles';

const StyledPrice = styled(PriceUnstyled)`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

type PriceProps = {
  price?: PriceType;
  pricePerNight?: PriceType;
  showPrice?: boolean;
  pricingType?: PricingTypeEnum;
  quantityLabel?: string | null;
};

export const Price: FC<PriceProps> = ({
  price,
  pricePerNight,
  showPrice,
  pricingType,
  quantityLabel,
}) =>
  showPrice && price ? (
    <PriceWrapper>
      <div data-testid="price-total">
        <StyledPrice price={price} />
      </div>
      <PricingType
        pricingType={pricingType}
        quantityLabel={quantityLabel}
        pricePerNight={pricePerNight}
        price={price}
      />
    </PriceWrapper>
  ) : null;
